export { default } from "./FavoriteCategories.jsx";
